export const handleValidation = (email, ticketId, ticket, variant) => {
    validateTicket(ticketId);
    validateVariant(ticket, variant);
};

const validateTicket = (ticketId) => {
    if (!ticketId) throw "Please select a ticket";
};

// SELL06 — a cash sale of a variant product must pick the SKU handed over.
const validateVariant = (ticket, variant) => {
    if (ticket?.variants?.length > 0 && !variant) throw "Please pick an option";
};
